import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { bookingShape } from 'constants/propTypes';
import {
  StyleHeaderItems,
  StyleHeaderItem,
  StyledBody
} from 'components/ui/BookingPathReviewBookingSummary/BookingPathReviewBookingSummary.styles';
import SectionHeaderTitle from 'components/ui/BookingPathReviewBookingSummary/SectionHeaderTitle';
import SectionHeaderBar from 'components/ui/BookingPathReviewBookingSummary/SectionHeaderBar';
import { mapExtraInfo } from './ReviewExtrasSummary.utils';
import SegmentSummary from './SegmentSummary';

const ReviewExtrasSummary = ({ title, booking = {} }) => {
  const { reference, outbound, inbound, outboundExtras, inboundExtras } = booking;

  const cancelledOutboundExtras = outboundExtras.filter((extra) => extra.cancelled && extra.provisional);
  const newOutboundExtras = outboundExtras.filter((extra) => !extra.cancelled && extra.provisional);
  const cancelledInboundExtras = inboundExtras.filter((extra) => extra.cancelled && extra.provisional);
  const newInboundExtras = inboundExtras.filter((extra) => !extra.cancelled && extra.provisional);

  const newExtras = {
    outbound: outbound
      .map((leg) => (leg.cancelled ? null : mapExtraInfo(leg, newOutboundExtras)))
      .filter((leg) => leg && leg.extras.length > 0),
    inbound: inbound
      .map((leg) => (leg.cancelled ? null : mapExtraInfo(leg, newInboundExtras)))
      .filter((leg) => leg && leg.extras.length > 0)
  };
  const cancelledExtras = {
    outbound: outbound.map((leg) => mapExtraInfo(leg, cancelledOutboundExtras)).filter((leg) => leg.extras.length > 0),
    inbound: inbound.map((leg) => mapExtraInfo(leg, cancelledInboundExtras)).filter((leg) => leg.extras.length > 0)
  };

  const [isActive, setIsActive] = useState(true);

  return (
    <>
      <SectionHeaderBar>
        <SectionHeaderTitle titleId={title} isActive={isActive} setIsActive={setIsActive} />
        {reference && (
          <StyleHeaderItems data-testid="extras-details" className="booking-pnr">
            <FormattedMessage id="searchBooking.pnr" />
            <StyleHeaderItem data-testid="pnr">{reference}</StyleHeaderItem>
          </StyleHeaderItems>
        )}
      </SectionHeaderBar>

      <StyledBody hide={!isActive}>
        <SegmentSummary newExtras={newExtras} cancelledExtras={cancelledExtras} />
      </StyledBody>
    </>
  );
};

ReviewExtrasSummary.propTypes = {
  title: PropTypes.string,
  booking: bookingShape
};

export default ReviewExtrasSummary;
